// Ключи для localStorage
const SHIFT_LAST_START_TIME_KEY = 'shifts:last_start_time'
const SHIFT_LAST_END_TIME_KEY = 'shifts:last_end_time'

// Получение сохраненного времени начала смены
export const getLastShiftStartTime = (): string => {
  return localStorage.getItem(SHIFT_LAST_START_TIME_KEY) || '09:00'
}

// Получение сохраненного времени окончания смены
export const getLastShiftEndTime = (): string => {
  return localStorage.getItem(SHIFT_LAST_END_TIME_KEY) || '21:00'
}

// Сохранение времени начала смены
export const saveLastShiftStartTime = (time: string): void => {
  localStorage.setItem(SHIFT_LAST_START_TIME_KEY, time)
}

// Сохранение времени окончания смены
export const saveLastShiftEndTime = (time: string): void => {
  localStorage.setItem(SHIFT_LAST_END_TIME_KEY, time)
}

// Объединение даты и времени
export const combineDateAndTime = (date: Date, timeStr: string): Date => {
  const [hours, minutes] = timeStr.split(':').map(Number)
  const result = new Date(date)
  result.setHours(hours, minutes, 0, 0)
  return result
}
